export default __webpack_public_path__ + "static/media/323.6559fa7c.png";